// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestEnvironmentSpec } from './RequestEnvironmentSpec';
import {
  RequestEnvironmentSpecFromJSON,
  RequestEnvironmentSpecFromJSONTyped,
  RequestEnvironmentSpecToJSON,
  RequestEnvironmentSpecToJSONTyped,
} from './RequestEnvironmentSpec';

/**
 *
 * @export
 * @interface ResponseEnvironmentConfig
 */
export interface ResponseEnvironmentConfig {
  /**
   * Environment configuration request.EnvironmentSpec
   * This is the same spec as used when submitting the environment config.
   * @type {RequestEnvironmentSpec}
   * @memberof ResponseEnvironmentConfig
   */
  config?: RequestEnvironmentSpec;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentConfig
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentConfig
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentConfig
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentConfig
   */
  modifiedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentConfig
   */
  modifiedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentConfig
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentConfig
   */
  team?: string;
}

/**
 * Check if a given object implements the ResponseEnvironmentConfig interface.
 */
export function instanceOfResponseEnvironmentConfig(
  value: object,
): value is ResponseEnvironmentConfig {
  return true;
}

export function ResponseEnvironmentConfigFromJSON(
  json: any,
): ResponseEnvironmentConfig {
  return ResponseEnvironmentConfigFromJSONTyped(json, false);
}

export function ResponseEnvironmentConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentConfig {
  if (json == null) {
    return json;
  }
  return {
    config:
      json['config'] == null
        ? undefined
        : RequestEnvironmentSpecFromJSON(json['config']),
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    createdBy: json['created_by'] == null ? undefined : json['created_by'],
    description: json['description'] == null ? undefined : json['description'],
    modifiedAt: json['modified_at'] == null ? undefined : json['modified_at'],
    modifiedBy: json['modified_by'] == null ? undefined : json['modified_by'],
    name: json['name'] == null ? undefined : json['name'],
    team: json['team'] == null ? undefined : json['team'],
  };
}

export function ResponseEnvironmentConfigToJSON(
  json: any,
): ResponseEnvironmentConfig {
  return ResponseEnvironmentConfigToJSONTyped(json, false);
}

export function ResponseEnvironmentConfigToJSONTyped(
  value?: ResponseEnvironmentConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    config: RequestEnvironmentSpecToJSON(value['config']),
    created_at: value['createdAt'],
    created_by: value['createdBy'],
    description: value['description'],
    modified_at: value['modifiedAt'],
    modified_by: value['modifiedBy'],
    name: value['name'],
    team: value['team'],
  };
}
